"use client";

import dynamic from "next/dynamic";

export const CartModal = dynamic(() =>
  import("./CartModal").then((mod) => mod.CartModal),
);

export { useCart } from "./hooks";
